
import axios from "axios";
import {  ADD_ROW, GET_ALL_SHEETS, DELETE_ROW, GET_ONE_SHEET, SET_ERROR, SET_LOADING, ADD_ROW_SUCCESS, ADD_ROW_FAILURE, SAVE_SHEET, UPDATE_SHEET_ROWS, UPDATE_ROW_QUANTITY} from "../ActionTypes/TechnicalSheetTypes";

// Ajouter une ligne à la fiche technique
export const addRow = (rowData) => async (dispatch) => {
  dispatch({ type: ADD_ROW }); // Indique que l'ajout commence
  try {
    const response = await axios.post("/api/TechnicalSheet/add-row", rowData);
    dispatch({ type: ADD_ROW_SUCCESS, payload: response.data }); // Succès
    alert("Ligne ajoutée avec succès !");
  } catch (error) {
    dispatch({ type: ADD_ROW_FAILURE, payload: error.message }); // Échec
    alert("Erreur lors de l'ajout de la ligne : " + error.message);
  }
};


export const saveSheet = (sheetData) => async (dispatch) => {
  try {
    const response = await axios.post("/api/TechnicalSheet/save-sheet", sheetData);
    dispatch({ type: SAVE_SHEET, payload: response.data });
    alert("Fiche technique sauvegardée avec succès !");
  } catch (error) {
    console.error("Erreur lors de la sauvegarde :", error.message);
    alert("Erreur lors de la sauvegarde de la fiche technique.");
  }
};
    


// Obtenir toutes les fiches techniques
export const getAllSheets = () => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axios.get("/api/TechnicalSheet/all-sheets");
    dispatch({ type: GET_ALL_SHEETS, payload: response.data });
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.message || "Erreur lors de la récupération.",
    });
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Supprimer une ligne d'une fiche technique
export const deleteRow = (id) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    await axios.delete(`/api/TechnicalSheet/delete-row/${id}`);
    dispatch({ type: DELETE_ROW, payload: id });
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.message || "Erreur lors de la suppression.",
    });
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Obtenir une fiche technique par ID
export const getOneSheet = (id) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axios.get(`/api/TechnicalSheet/onesheet/${id}`);
    dispatch({ type: GET_ONE_SHEET, payload: response.data });
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.message || "Erreur lors de la récupération.",
    });
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Mettre à jour toutes les lignes d'une fiche technique
export const updateSheetRows = (sheetId, rows) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axios.put(`/api/TechnicalSheet/${sheetId}`, { rows });
    dispatch({ 
      type: UPDATE_SHEET_ROWS, 
      payload: { sheetId, rows: response.data.sheet.rows }
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.message || "Erreur lors de la mise à jour.",
    });
    throw error;
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Mettre à jour la quantité d'un ingrédient spécifique
export const updateRowQuantity = (sheetId, rowId, quantity) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axios.put(
      `/api/TechnicalSheet/${sheetId}/row/${rowId}/quantity`, 
      { quantity }
    );
    dispatch({ 
      type: UPDATE_ROW_QUANTITY, 
      payload: { 
        sheetId, 
        rowId, 
        quantity,
        updatedSheet: response.data.sheet
      }
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.message || "Erreur lors de la mise à jour de la quantité.",
    });
    throw error;
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};